import {BS2} from "../../BS2";
import {BS2GameAssets} from "../../BS2GameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";

/**
 * Created by jonas on 2023-01-27.
 */

export class HotFrame extends PIXI.Container{
    private sprite:PIXI.Sprite;
    private loopAnimation:gsap.core.Timeline;

    constructor() {
        super();
        this.name="hotFrame";
        this.sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.TRANSITION_HOT_FRAME)[0]);
        this.sprite.blendMode = PIXI.BLEND_MODES.ADD;
        this.sprite.anchor.set(0.5,0.5);
        this.addChild(this.sprite);
        this.hide(0);
    }

    public resize(){
        this.sprite.width = NolimitApplication.screenBounds.width;
        this.sprite.height = NolimitApplication.screenBounds.height;
    }

    public show(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{
            this.startLoop();
        })
        tl.add(gsap.to(this, {duration:duration, alpha:1, ease:"none"}));
        return tl;
    }

    public hide(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{
            this.stopLoop();
        });
        tl.add(gsap.to(this, {duration:duration, alpha:0, ease:"none"}));
        return tl;
    }


    private startLoop():void {
        if (!this.loopAnimation) {
            this.loopAnimation = gsap.timeline({repeat:-1});
            this.loopAnimation.add(gsap.to(this.sprite, {duration:0.3, alpha:0, ease:"none"}));
            this.loopAnimation.add(gsap.to(this.sprite, {duration:0.3, alpha:1, ease:"none"}));
        }
        this.loopAnimation.play(0);
    }
    private stopLoop():void {
        if (this.loopAnimation) {
            this.loopAnimation.pause();
        }
    }
}